"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slugify = void 0;
const slugify = (str) => {
    if (!str)
        return null;
    return str
        .toLowerCase()
        .replace(/[/\s]+/g, "-") // Replace slashes and spaces with hyphens
        .replace(/-+/g, "-")
        .trim(); // Remove any leading/trailing spaces or hyphens
};
exports.slugify = slugify;
